module.exports = __webpack_public_path__ + "img/househomeTop.92d991f1.jpeg";